import React from 'react';
// import { Link } from 'react-router-dom';
import { InfoWraper } from './auth-info-style';
// import { Popover } from '../../popup/popup';

function AuthInfo() {

  // const userContent = (<></>);

  return (
    <>
      <InfoWraper>
        <div className="nav-author">
          {/* <Popover placement="bottomRight" content={userContent} action="click"> */}
          <span className="head-example">
            <span className='details_span_Tag UserIcon' style={{ display: "flex", width: "32px", height: "32px", fontSize: "19px", color: "#272b41", background: "#bebfc6" }}>
              LM
            </span>
          </span>
          {/* </Popover> */}
        </div>
      </InfoWraper>
    </>
  );
}

export default AuthInfo;
